var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
// https://prototype.sqprod.co/#/docs/squareup.credittracking.service.ActivityType
export let CreditActivityType = /*#__PURE__*/function (CreditActivityType) {
  CreditActivityType["ACTIVATE"] = "ACTIVATE";
  CreditActivityType["ADJUST_DECREMENT"] = "ADJUST_DECREMENT";
  CreditActivityType["ADJUST_INCREMENT"] = "ADJUST_INCREMENT";
  CreditActivityType["MODIFY_VALIDITY"] = "MODIFY_VALIDITY";
  CreditActivityType["PACK_REFUND"] = "PACK_REFUND";
  CreditActivityType["REDEEM_COMPLETED"] = "REDEEM_COMPLETED";
  CreditActivityType["REDEEM_PENDING"] = "REDEEM_PENDING";
  CreditActivityType["REDEMPTION_REFUND"] = "REDEMPTION_REFUND";
  return CreditActivityType;
}({});
// https://prototype.sqprod.co/#/docs/squareup.credittracking.service.CreditActivity
let CreditActivity = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('number'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = fragment('activate-activity-details-fragment'), _dec7 = fragment('adjust-decrement-activity-details-fragment'), _dec8 = fragment('adjust-increment-activity-details-fragment'), _dec9 = fragment('modify-validity-activity-details-fragment'), _dec10 = fragment('redeem-completed-activity-details-fragment'), _dec11 = fragment('redeem-pending-activity-details-fragment'), _dec12 = fragment('refund-activity-details-fragment'), _class = class CreditActivity extends EmberDataBaseModel {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "createdAt", _descriptor, this);
    _initializerDefineProperty(this, "creditPackId", _descriptor2, this);
    _initializerDefineProperty(this, "resultingQuantity", _descriptor3, this);
    // Only present if the activity status is COMPLETED
    _initializerDefineProperty(this, "type", _descriptor4, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor5, this);
    // Only populated if type is ACTIVATE
    _initializerDefineProperty(this, "activateActivityDetails", _descriptor6, this);
    // Only populated if type is ADJUST_DECREMENT
    _initializerDefineProperty(this, "adjustDecrementActivityDetails", _descriptor7, this);
    // Only populated if type is ADJUST_INCREMENT
    _initializerDefineProperty(this, "adjustIncrementActivityDetails", _descriptor8, this);
    // Only populated if type is MODIFY_VALIDITY
    _initializerDefineProperty(this, "modifyValidityActivityDetails", _descriptor9, this);
    // Only populated if type is REDEEM_COMPLETED
    _initializerDefineProperty(this, "redeemCompletedActivityDetails", _descriptor10, this);
    // Only populated if type is REDEEM_PENDING
    _initializerDefineProperty(this, "redeemPendingActivityDetails", _descriptor11, this);
    // Only populated if type is REDEMPTION_REFUND
    _initializerDefineProperty(this, "refundActivityDetails", _descriptor12, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "creditPackId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "resultingQuantity", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "activateActivityDetails", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "adjustDecrementActivityDetails", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "adjustIncrementActivityDetails", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "modifyValidityActivityDetails", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "redeemCompletedActivityDetails", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "redeemPendingActivityDetails", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "refundActivityDetails", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CreditActivity as default };
CreditActivity.reopenClass({
  _modelNameForMigration: 'credit-activity'
});